import utilsStyles from '@/styles/modules/utils.module.scss';
import clsx from 'clsx';
import styles from './OptionTitle.module.scss';

type OptionTitleSize = 'default' | 'small';

const SIZE_CLASS: Record<OptionTitleSize, string> = {
  default: styles.sizeDefault,
  small: styles.sizeSmall,
};

function OptionTitle({
  title,
  linkText,
  onLinkClick,
  size = 'default',
}: {
  title: string;
  linkText?: string;
  onLinkClick?: () => void;
  size?: OptionTitleSize;
}) {
  return (
    <div className={clsx(styles.productOptionTitle, SIZE_CLASS[size])}>
      <p className={styles.productOptionTitleText}>{title}</p>
      {linkText && (
        <p className={clsx(utilsStyles.textLink, styles.productOptionLink)} onClick={onLinkClick}>
          {linkText}
        </p>
      )}
      <hr className={styles.productOptionTitleHr} />
    </div>
  );
}

export default OptionTitle;
